'use strict';

exports = module.exports = {
  // List of user roles
  userRoles: ['shop', 'viewer', 'manager', 'admin']
};



//////////////////
// WEBPACK FOOTER
// ./server/config/environment/shared.js
// module id = 18
// module chunks = 0